import { CartItem, ShippingItem } from '@pedix-workspace/utils';
export function transformCartItemsToShippingItems(cartItems: CartItem[]): ShippingItem[] {
  const shippingItems: ShippingItem[] = [];

  for (const cartItem of cartItems) {
    const items = cartItem.selectedPresentation?.items || [cartItem.product];
    for (const item of items) {
      const weight = item.weight;
      const height = item.height;
      const length = item.length;
      const width = item.width;

      if (!weight || !height || !length || !width) {
        console.error('Falta el peso, altura, longitud o ancho en uno de los productos.');
        return [];
      }

      shippingItems.push({
        description: cartItem.product.name,
        quantity: cartItem.qty,
        value: cartItem.product.price,
        weight: weight,
        height: height,
        length: length,
        width: width,
      });
    }
  }

  return shippingItems;
}
